import { PremiumSection } from '../shared/PremiumSection'
import { PremiumHeading } from '../shared/PremiumHeading'

const PROBLEMS = [
  {
    title: 'Context drift',
    description:
      'The agent starts on-task and ends somewhere else. Your instructions and context files were written for a smaller repo and never updated as it grew.',
  },
  {
    title: 'Review costs more than writing',
    description:
      'Generated code takes longer to read and verify than writing it yourself would have taken. The speed shows up in the first draft and disappears in review.',
  },
  {
    title: 'Quiet architecture drift',
    description:
      'Nothing breaks. Abstractions get weaker, tests thin out, and the shape of the codebase moves a little every week until it is hard to change.',
  },
  {
    title: 'Tools keep moving',
    description:
      'A new model, a new agent, a new config format. What survives the churn is a process, and most people never had one to begin with.',
  },
]

export function ProblemSection() {
  return (
    <PremiumSection id="problem" containerClassName="max-w-4xl">
      <PremiumHeading as="h2">
        Where AI coding actually goes wrong
      </PremiumHeading>
      <p className="mb-10 max-w-2xl leading-relaxed text-[#c3ccc7]">
        Not in the demo. In week three, on the codebase you have to keep working
        in.
      </p>
      <div className="grid gap-x-10 gap-y-8 md:grid-cols-2">
        {PROBLEMS.map((problem) => (
          <div key={problem.title} className="border-l-2 border-[#2e3833] pl-5">
            <h3 className="mb-2 font-semibold text-[#f0f3f1]">
              {problem.title}
            </h3>
            <p className="leading-relaxed text-[#c3ccc7]">
              {problem.description}
            </p>
          </div>
        ))}
      </div>
    </PremiumSection>
  )
}
